import React, { useState ,useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
// import goldbadge from "./Assets/Gold badge.svg";
// import goldbadge from "./Assets/badgeoptimised.svg";
import goldbadge from "./Assets/badgepng.png";
import VLITopLogo from "./Assets/VLITopLogo.png"
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { QRCodeCanvas } from "qrcode.react";
import OwnerSignature from "./Assets/OwnerSignature.png";
import { useDispatch, useSelector } from "react-redux";
import { GetCourseCertificateData } from '../../Actions/CourseA';
import { GetLocalStorage } from '../../Helpers/LocalStorage/LocalStorage';
import { BaseUrl } from '../../Actions/Base';
import Footer from '../../Components/Footer/Footer';
import { usePDF } from "react-to-pdf";

const CourseCompletionCertificate = () => {
    const location = useLocation();
    const enrollmentId = location.state?.enrollmentId;
    const Dispatch = useDispatch();
    const UserId = GetLocalStorage("UserInfo")?.UserId;
    console.log("UserId in PaymentInstallmentsInvoice is:",UserId)
    const [isDownloading, setIsDownloading] = useState(false);


    const ref = useRef();
    const { toPDF } = usePDF({ filename: "certificate.pdf", documentTitle: "Certificate" });

    const { courseCourseCertificateData } = useSelector(
        (Store) => Store.CourseReducer
      );

    console.log("courseCourseCertificateData in PaymentInstallmentsInvoice is:",courseCourseCertificateData)

    useEffect(() => {
        if(enrollmentId){
        Dispatch(GetCourseCertificateData(enrollmentId, UserId));
        }
    }, [Dispatch, enrollmentId, UserId]);

    console.log("Received Enrollment ID:", enrollmentId);
    let ButtonStyle = `text-white text-center w-fit min-w-[200px] py-3 rounded-[9px] whitespace-nowrap border-none px-4 cursor-pointer SemiBold
    text-3xs md:text-3xs lg:text-2xs xl:text-xs
    `
    const borderStyle = { border: "1px solid black" };

    const preloadImage = (src) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            img.crossOrigin = "anonymous"; // Ensures no CORS issues
            img.onload = resolve;
            img.onerror = reject;
        });
    };

    const downloadCertificate = () => {
        setIsDownloading(true);
        
        requestAnimationFrame(() => {
            setTimeout(() => {
                const content = document.getElementById("downloadContent");
    
                if (!content) {
                    console.error("Certificate content not found!");
                    setIsDownloading(false);
                    return;
                }
    
                html2canvas(content, { scale: 2 }).then((canvas) => {
                    const imgData = canvas.toDataURL("image/png");
    
                    const pdf = new jsPDF("p", "mm", "a4");
                    const imgWidth = 210;
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
                    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
                    pdf.save("Course-Certificate.pdf");
    
                    setIsDownloading(false);
                });
            }, 100); // A small delay to let the browser render the new styles
        });
    };
    

    const qrUrl = window.location.origin; // Gets the base URL dynamically
    const qrData = `${qrUrl}/verifycertificate/${courseCourseCertificateData?.studentCertificate?.CertificateId}`;
        
    return(
        <>
        <div className='mt-[130px] w-full flex justify-center items-center'>
            <div className='w-[80%] flex flex-col gap-[10px]'>
                <p className='text-[45px] text-[#290A69] text-center font-bold'>Certificate For {courseCourseCertificateData?.course?.CourseName}</p>
                <p className='text-[26px] text-[#290A69] text-center font-semibold'>{courseCourseCertificateData?.course?.Description}</p>

                <div
                    style={{
                        backgroundImage: "url('/assets/certificate/2y.png')",
                        backgroundSize: "cover",  // Ensures the image covers the entire div
                        backgroundPosition: "center", // Centers the image
                        backgroundRepeat: "no-repeat", // Prevents tiling
                        height: "800px", // Set the height explicitly
                        width: "100%", // Full width
                    }}
                    className="w-full mt-[40px] flex justify-center"
                    id="downloadContent"
                    ref={ref}
                    >
                        <div className='w-[85%] flex flex-col'>
                            <div className='w-full flex items-center gap-[60px]'>
                                    <div className='flex flex-col mt-[50px] pb-[10px]'
                                    style={{
                                        borderBottom:"1px solid #8B55FF"
                                    }}>
                                        <p className="AthelasBold text-[37px] text-[#58595B] ml-[25px] w-[600px]">VEHICLE LEARNING INNOVATION</p>
                                        <p className="AthelasBold text-[37px] text-[#8B55FF] ml-[25px]">CERTIFICATE OF COMPLETION</p>
                                    </div>
                                    <img src={VLITopLogo} alt="VLITopLogo" className="w-[200px] mt-[100px]" />
                            </div>

                            <div className='w-full flex justify-between '>
                                <div className='w-[68%] flex flex-col gap-[10px] ml-[25px]'>
                                    <p className={`Myriadpro text-[21px] text-[#231F20] ${isDownloading ? 'mt-[-10px]' : 'mt-[-20px]'}`}>Certificate ID: {courseCourseCertificateData?.studentCertificate?.CertificateId}</p>
                                    <p className={`HelveticaNeueMedium text-[27px] text-[#231F20] ${isDownloading ? 'mt-[0px]' : 'mt-[20px]'}`}>This is to certify that </p>
                                    <p className="HelveticaNeueMedium text-[52px] text-[#8B55FF]">{courseCourseCertificateData?.student?.FirstName} {courseCourseCertificateData?.student?.LastName}</p>
                                    <p className={`HelveticaNeueRoman text-[19px] text-[#231F20] ${isDownloading ? 'mt-[0px]' : 'mt-[20px]'}`}>Has completed</p>

                                    <div style={{ overflowX: "auto" }}>
                                        <table style={{ borderCollapse: "collapse", width: "100%", textAlign: "center", ...borderStyle }}>
                                            <thead>
                                            <tr style={borderStyle}>
                                                <th className="HelveticaNeueMedium" style={{ ...borderStyle, padding: "8px" }}>Class Type</th>
                                                <th className="HelveticaNeueRoman" style={{ ...borderStyle, padding: "8px" }}>In-Vehicle</th>
                                                <th className="HelveticaNeueRoman" style={{ ...borderStyle, padding: "8px" }}>Online/Other</th>
                                                <th className="HelveticaNeueRoman" style={{ ...borderStyle, padding: "8px" }}>In-Class</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr style={borderStyle}>
                                                <td className="HelveticaNeueMedium" style={{ ...borderStyle, padding: "8px", fontWeight: "600" }}>Hours</td>
                                                <td className="HelveticaNeueRoman" style={{ ...borderStyle, padding: "8px" }}>{courseCourseCertificateData?.coursePackage?.DrivingHours}</td>
                                                <td className="HelveticaNeueRoman" style={{ ...borderStyle, padding: "8px" }}>{courseCourseCertificateData?.coursePackage?.OnlineHours}</td>
                                                <td className="HelveticaNeueRoman" style={{ ...borderStyle, padding: "8px" }}>{courseCourseCertificateData?.coursePackage?.InClassHours}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <p className=" text-[19px] text-[#231F20] ">For {courseCourseCertificateData?.course?.CourseName} to meet the requirement for {courseCourseCertificateData?.licenseType?.LicenseTypeName} License at  {courseCourseCertificateData?.institute?.InstituteName} during the period from {courseCourseCertificateData?.timeTable?.startDate &&
                                        new Date(courseCourseCertificateData.timeTable.startDate).toISOString().split("T")[0]} To {courseCourseCertificateData?.timeTable?.endDate &&
                                        new Date(courseCourseCertificateData.timeTable.endDate).toISOString().split("T")[0]}
                                        .</p>

                                    <div className={`w-full flex items-center gap-[20px] ${isDownloading ? 'mt-[10px]' : 'mt-[15px]'}`}>
                                        <div className='w-[30%] flex flex-col justify-center items-center gap-[10px]'>
                                                <p className="Myriadpro text-[21px] text-[#000000]">Training Provider</p>
                                                <img
                                                    className={`${isDownloading ? 'w-[80px] h-[80px]' : 'w-[120px] h-[120px]'}`}
                                                    src={
                                                        courseCourseCertificateData
                                                            ? `${BaseUrl}/api/vehicletype/image?url=${courseCourseCertificateData?.institute?.InstituteLogo}`
                                                            : null
                                                    }
                                                    alt="Logo"
                                                />
                                            {/* <img src={goldbadge} alt="goldbadge" className="w-[200px]" />  */}
                                        </div>
                                        <div className={`w-[70%] flex py-[10px] flex-col ${isDownloading ? 'gap-[0px]' : 'gap-[5px]'}`}
                                         style={{
                                            borderBottom:"1px solid #8B55FF",
                                            borderTop:"1px solid #8B55FF"
                                        }}>
                                            <img src={OwnerSignature} alt="OwnerSignature" className="w-[100px]" />
                                            <p className="HelveticaNeueBold text-[15px] text-[#231F20]">{courseCourseCertificateData?.InstituteOwner?.FirstName} {courseCourseCertificateData?.InstituteOwner?.LastName}</p>
                                            <p className="HelveticaNeueMedium text-[14px] text-[#231F20]">Owner of</p>
                                            <p className="HelveticaNeueMedium text-[14px] text-[#231F20]">{courseCourseCertificateData?.institute?.InstituteName}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='w-[25%] flex flex-col gap-[5px] mt-[80px]'>

                                    {/* <div className="w-[200px] h-[200px]"
                                    style={{ ...borderStyle}}>
                                    </div> */}
                                    <img id="badgeImage" src={goldbadge} alt="goldbadge" className="w-[200px]" />
                                    <p className="HelveticaNeueBold text-[12px] text-[#000000] mt-[10px]">Verify at:</p>
                                    <QRCodeCanvas value={qrData} size={50} />
                                    <p className="HelveticaNeueRoman text-[10px] text-[#000000] w-[80px]">{qrData}</p>
                                    <p className="HelveticaNeueMedium text-[12px] text-[#000000] mt-[10px]">VLI certifies that this individual's identity has been verified and he/she has successfully participated in the training program.</p>
                                </div>
                            </div>
                        </div>
                </div>

                <div className='w-full flex justify-end mt-[40px]'>
                    <button
                    onClick={downloadCertificate}
                    className={`${ButtonStyle} text-white bg-[#A1A3EF] ml-[150px]`}
                    // onClick={() => toPDF(ref)}
                    >
                        Download
                    </button>
                </div>
            </div>
        </div>

        <Footer />
        </>
    )
}

export default CourseCompletionCertificate
